import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'

import {
  CHART_ACTIVE_DOT,
  CHART_ANIMATION,
  CHART_AXIS_LINE,
  CHART_AXIS_TICK,
  CHART_GRID_PROPS,
  CHART_LEGEND_STYLE,
  CHART_MARGIN,
  CHART_TOOLTIP_STYLE
} from './chartTheme'

export const LineChartComponent = ({
  data,
  xaxis,
  yaxis,
  cartesian,
  legend,
  dataKeys,
  yAxisProps,
  xAxisProps,
  tooltipProps
}) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={data} margin={CHART_MARGIN}>
        {cartesian ? <CartesianGrid {...CHART_GRID_PROPS} /> : null}
        {xaxis ? (
          <XAxis
            dataKey={typeof xaxis === 'string' ? xaxis : 'name'}
            tick={CHART_AXIS_TICK}
            axisLine={CHART_AXIS_LINE}
            tickLine={false}
            {...xAxisProps}
          />
        ) : null}
        {yaxis ? (
          <YAxis tick={CHART_AXIS_TICK} axisLine={false} tickLine={false} {...yAxisProps} />
        ) : null}
        <Tooltip contentStyle={CHART_TOOLTIP_STYLE} {...tooltipProps} />
        {legend ? (
          <Legend wrapperStyle={CHART_LEGEND_STYLE} iconType="circle" iconSize={8} />
        ) : null}
        {dataKeys.map((dk) => (
          <Line
            type="monotone"
            dataKey={dk.dataKey}
            key={dk.dataKey}
            stroke={dk.color}
            strokeWidth={2.5}
            dot={false}
            activeDot={CHART_ACTIVE_DOT(dk.color)}
            animationDuration={CHART_ANIMATION.duration}
            animationEasing={CHART_ANIMATION.easing}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  )
}
